<div class="datepicker-container">
  <mat-calendar #calendar [selected]="innerValue()" (selectedChange)="setDate($event)" [minDate]="minDate()" [maxDate]="maxDate()" />
</div>
